import reducer from './reducers';

export { default as equipmentSelectors } from './selectors';
export { default as equipmentOperations } from './operations';
export { default as equipmentTypes } from './types';

export default reducer;
